import StatusDropdown from "./StatusDropdown";

export default function UserDetailCard({ role = "Educator" ,user}) {

    console.log(user, 'hggdhsdgfhjdsfhjdsg')
    return (
        <div className="my-3">
            <div className="w-full bg-white rounded-2xl shadow p-6">
                {/* Profile Image */}
                <div className="flex flex-col items-center">
                    <img
                        src={user?.profile_pic || ''}
                        alt="Profile"
                        className="w-28 h-28 rounded-full border"
                    />
                    <h2 className="mt-4 text-lg font-semibold text-gray-800">{user?.full_name}</h2>
                    <a
                        href="mailto:Michel@school.com"
                        className="text-primary-600 hover:underline text-md"
                    >
                       {user?.email}
                    </a>
                </div>

                {/* Role & Status */}
                <div className="flex justify-center gap-3 mt-4">
                    <span className="px-4 py-3 w-[140px] h-[44px] text-center text-sm rounded-lg bg-green-100 text-green-700 font-medium">
                        {user?.role_name}
                    </span>
                    <div>
                        <StatusDropdown />
                    </div>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-2 gap-4 mt-6">
                    <div className="border rounded-md p-3">
                        <p className="text-xl font-bold text-primary-800">{user?.student_count}</p>
                        <p className="text-sm text-gray-500">Total Students</p>
                    </div>
                    <div className="border rounded-md p-3">
                        <p className="text-xl font-bold text-primary-800">{user?.application_count}</p>
                        <p className="text-sm text-gray-500">Applications</p>
                    </div>
                    <div className="border rounded-md p-3 col-span-1">
                        <p className="text-md font-bold text-primary-800">{user?.created_at}</p>
                        <p className="text-sm text-gray-500">Account Created</p>
                    </div>
                    <div className="border rounded-md p-3 col-span-1">
                        <p className="text-md font-bold text-primary-800">{user?.last_login}</p>
                        <p className="text-sm text-gray-500">Last Login</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
